<div class="container-payment-body" *ngIf="paymentB2Crequest">
  <div class="container-payment px-md-5 py-md-3">
    <h3 class="text-center  heading4 mb-2">Payment Review</h3>
    <section class="mt-4">
      <div>
        <div class="row">
          <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex justify-content-center">
            <div>
              <div class="text-center">Order Reference #</div>
              <div class="text-center"><strong>{{paymentB2Crequest.OrderReference}}</strong></div>
            </div>
          </div>
          <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex justify-content-center">
            <div>
              <div class="text-center">Product</div>
              <div class="text-center"><strong>{{paymentB2Crequest.ProductType}}</strong></div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex justify-content-center">
            <div>
              <div class="text-center">Order Amount</div>
              <div class="text-center"><strong>{{paymentB2Crequest?.sOrderAmount}}</strong></div>
            </div>
          </div>
          <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex justify-content-center">
            <div>
              <div class="text-center">Product Description</div>
              <div class="text-center"><strong>{{paymentB2Crequest?.ProductDescription}}</strong></div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3">
        <form ngNoForm id="submitcheckout" [action]="jengapgwUrl" method="POST">
          <input type="hidden" id="token" name="token" [(ngModel)]="paymentB2Crequest.AccessToken" />
          <input type="hidden" id="merchantCode" name="merchantCode" [(ngModel)]="paymentB2Crequest.MerchantCode" />
          <input type="hidden" id="currency" name="currency" [(ngModel)]="paymentB2Crequest.Currency" />
          <input type="hidden" id="orderAmount" name="orderAmount" [(ngModel)]="paymentB2Crequest.OrderAmount" />
          <input type="hidden" id="orderReference" name="orderReference"
            [(ngModel)]="paymentB2Crequest.OrderReference" />
          <input type="hidden" id="productType" name="productType" [(ngModel)]="paymentB2Crequest.ProductType" />
          <input type="hidden" id="productDescription" name="productDescription"
            [(ngModel)]="paymentB2Crequest.ProductDescription" />
          <input type="hidden" id=" paymentTimeLimit " name=" paymentTimeLimit "
            [(ngModel)]="paymentB2Crequest.PaymentTimeLimt" />
          <input type="hidden" id="customerFirstName" name="customerFirstName"
            [(ngModel)]="paymentB2Crequest.CustomerFirstName" />
          <input type="hidden" id="customerLastName" name="customerLastName"
            [(ngModel)]="paymentB2Crequest.CustomerLastName" />
          <input type="hidden" id="customerPostalCodeZip" name="customerPostalCodeZip"
            [(ngModel)]="paymentB2Crequest.CustomerPostalCodeZip" />
          <input type="hidden" id="customerAddress" name="customerAddress"
            [(ngModel)]="paymentB2Crequest.CustomerAddress" />
          <input type="hidden" id="customerEmail" name="customerEmail" [(ngModel)]="paymentB2Crequest.CustomerEmail" />
          <input type="hidden" id="customerPhone" name="customerPhone" [(ngModel)]="paymentB2Crequest.CustomerPhone" />
          <input type="hidden" id="extraData" name="extraData" [(ngModel)]="paymentB2Crequest.ExtraData" />
          <input type="hidden" id="callbackUrl" name="callbackUrl" [(ngModel)]="paymentB2Crequest.CallbackUrl" />
          <input type="hidden" id="countryCode" name="countryCode" [(ngModel)]="paymentB2Crequest.Countrycode" />
          <div class="text-center">
            <button type="submit" class="px-5">Verify and Pay</button>
          </div>
        </form>
      </section>
    </section>
  </div>
</div>